var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13C25.5 6.09644 19.9036 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13C0.5 19.9036 6.09644 25.5 13 25.5C19.9036 25.5 25.5 19.9036 25.5 13Z",
    fill: "#00adef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13C25.5 6.09644 19.9036 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13C0.5 19.9036 6.09644 25.5 13 25.5C19.9036 25.5 25.5 19.9036 25.5 13Z",
    stroke: "#00adef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20.5C13.7767 20.5 14.4062 19.8704 14.4062 19.0938C14.4062 18.3171 13.7767 17.6875 13 17.6875C12.2233 17.6875 11.5938 18.3171 11.5938 19.0938C11.5938 19.8704 12.2233 20.5 13 20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14.875V13.9375C13.649 13.9375 14.2834 13.7451 14.823 13.3845C15.3626 13.024 15.7831 12.5115 16.0315 11.9119C16.2798 11.3124 16.3448 10.6526 16.2182 10.0161C16.0916 9.3796 15.7791 8.7949 15.3202 8.3361C14.8613 7.87717 14.2766 7.56466 13.6401 7.43805C13.0036 7.31144 12.3439 7.37642 11.7443 7.62477C11.1448 7.87312 10.6323 8.2937 10.2717 8.8333C9.91121 9.3729 9.71881 10.0073 9.71881 10.6563",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.69b2c7d3c5b46657cf0b6ac783bb1930.svg";
export { ForwardRef as ReactComponent };